import React, { useState } from 'react';
import { Modal, ModalHeader, ModalBody, SimpleWizard, SimpleWizardStep, SimpleWizardConfirmStep } from '@ygtechnologies/bygr-frontend-component-library';
import { Trans } from '@lingui/react/macro';
import { triggerHandler } from '@ygtechnologies/rubus-frontend-utilities';
import { cancelOrder } from '@/services/orders';
import theme from './OrderCancelDialog.module.scss';
import { faCheckCircle } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { OrderCloseDialogProps } from '.';

interface OptionOrderCancelDialogProps extends OrderCloseDialogProps {}

enum Step {
    Confirm = 1,
    Canceled = 2,
}

const PresetOrderCancelDialog: React.FC<OptionOrderCancelDialogProps> = ({ show, onClose, onOrderCancel, order }) => {
    const [step, setStep] = useState(Step.Confirm);
    const reset = () => {
        setStep(Step.Confirm);
    };

    const handleOpen = () => {
        reset();
    };

    const handleSubmit = async () => {
        await cancelOrder(order.id);
        triggerHandler(onOrderCancel, [order.id]);
    };

    const handleFinish = () => {
        triggerHandler(onClose);
    };

    const handleCancelClick = () => {
        triggerHandler(onClose);
    };

    return (
        <Modal isOpen={show} toggle={handleCancelClick} size="xl" onOpen={handleOpen}>
            <ModalHeader>
                <Trans>Cancel order</Trans>
            </ModalHeader>
            <ModalBody>
                <SimpleWizard
                    onCancel={handleCancelClick}
                    steps={[Step.Confirm, Step.Canceled]}
                    currentStep={step}
                    onStepChange={setStep}
                    onSubmit={handleSubmit}
                    onFinish={handleFinish}
                    saveButtonProps={{ children: <Trans>Cancel order</Trans> }}>
                    <SimpleWizardStep
                        stepNumber={Step.Confirm}
                        header={<Trans>Confirm cancellation of order #{order.id}</Trans>}>
                        <div className={theme.topText}>
                            <Trans>
                                You are about to cancel this order for buyer option {order.buyerOptionName}, this action is
                                not reversible, are you sure you want to do this?
                            </Trans>
                        </div>
                    </SimpleWizardStep>

                    <SimpleWizardConfirmStep
                        stepNumber={Step.Canceled}
                        header={
                            <Trans>
                                Cancellation of order {order.id}
                                confirmed
                            </Trans>
                        }>
                        <div className={theme.confirmed}>
                            <FontAwesomeIcon height="124px" width="124px" icon={faCheckCircle} className={theme.icon} />
                            <br />

                            <Trans>Order #{order.id} has been cancelled.</Trans>
                        </div>
                    </SimpleWizardConfirmStep>
                </SimpleWizard>
            </ModalBody>
        </Modal>
    );
};
export default PresetOrderCancelDialog;